'use strict';
import {Pipe, PipeTransform} from '@angular/core';
import {companyState} from '../../services/sessionState/companyState';

export function utcdate(input: string | Date, format = companyState.shortdate) {
    if (input) {
        if (typeof input === "string") {
            return input;
        } else {
            // TODO: we're using datejs to format. we should use moment, but we need to evaulate the date formats
            let d: any = new Date(input.getUTCFullYear(), input.getUTCMonth(), input.getUTCDate());
            return d.toString(format);
        }
    }
    return input;
};

export function utcdateFilter() {
    return utcdate;
}

@Pipe({name: 'utcdate'})
export class UtcDatePipe implements PipeTransform {
    transform(input: string|Date, format: string = companyState.shortdate) {
        return utcdate(input, format);
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/utcdateFilter.ts